module.exports = __webpack_public_path__ + "img/5.d0b9c458.png";